/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeaveRequest } from './LeaveRequest';
import {
    LeaveRequestFromJSON,
    LeaveRequestFromJSONTyped,
    LeaveRequestToJSON,
    LeaveRequestToJSONTyped,
} from './LeaveRequest';

/**
 * 
 * @export
 * @interface CreateLeaveRequestResponse
 */
export interface CreateLeaveRequestResponse {
    /**
     * 
     * @type {LeaveRequest}
     * @memberof CreateLeaveRequestResponse
     */
    data: LeaveRequest;
}

/**
 * Check if a given object implements the CreateLeaveRequestResponse interface.
 */
export function instanceOfCreateLeaveRequestResponse(value: object): value is CreateLeaveRequestResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateLeaveRequestResponseFromJSON(json: any): CreateLeaveRequestResponse {
    return CreateLeaveRequestResponseFromJSONTyped(json, false);
}

export function CreateLeaveRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeaveRequestResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': LeaveRequestFromJSON(json['data']),
    };
}

  export function CreateLeaveRequestResponseToJSON(json: any): CreateLeaveRequestResponse {
      return CreateLeaveRequestResponseToJSONTyped(json, false);
  }

  export function CreateLeaveRequestResponseToJSONTyped(value?: CreateLeaveRequestResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': LeaveRequestToJSON(value['data']),
    };
}

